import React, { useReducer } from 'react';
import {
  Routes,
  Route,
  BrowserRouter,
} from 'react-router-dom';

import { DispatchContext } from '../../contexts/DispatchContext';
import { StateContext } from '../../contexts/StateContext';
import { initializer } from '../../reducer/initializer';
import { reducer } from '../../reducer/reducer';
import { Session } from '../../types/Session';
import SchedulerPage from './pages/SchedulerPage';
import {createTheme, ThemeProvider} from "@mui/material/styles";
import {NotFound} from "../NotFound/NotFound";
import {ActivityPricePage} from "./pages/ActivityPricePage";
import {Container} from "./components/Container";
import {GuideSchedulePage} from "./pages/GuideSchedulePage";

interface Props {
  session: Session;
}

export const GuidePages: React.ComponentType<Props> = ({ session }) => {
  const [state, dispatch] = useReducer(reducer, session, initializer);

  const theme = createTheme({
    palette: {
      primary: {
        main: '#2c65de',
      },
      secondary: {
        main: '#256861',
      },
    },
    typography: {
      h1: {
        fontSize: '2rem',
        '@media (max-width:600px)': {
          fontSize: '1.5rem',
        },
      },
      h2: {
        fontSize: '1.75rem',
        '@media (max-width:600px)': {
          fontSize: '1.3rem',
        },
      },
      h3: {
        fontSize: '1.5rem',
        '@media (max-width:600px)': {
          fontSize: '1.15rem',
        },
      },
      h4: {
        fontSize: '1.25rem',
        '@media (max-width:600px)': {
          fontSize: '1.0rem',
        },
      },

      h5: {
        fontSize: '1.15rem',
        '@media (max-width:600px)': {
          fontSize: '0.95rem',
        },
      },
      h6: {
        fontSize: '1rem',
        '@media (max-width:600px)': {
          fontSize: '0.85rem',
        },
      },

      body1: {
        fontSize: '1rem',
        '@media (max-width:600px)': {
          fontSize: '0.875rem',
        },
      },
      body2: {
        fontSize: '11px',
        lineHeight: '13px',
        '@media (max-width:600px)': {
          fontSize: '10px',
        },
      },
      caption: {
        fontSize: '0.7rem',
        '@media (max-width:600px)': {
          fontSize: '0.6rem',
        },
      },
    },
  });

  return (
    <DispatchContext.Provider value={dispatch}>
      <StateContext.Provider value={state}>
        <ThemeProvider theme={theme}>
          <BrowserRouter>
            <Routes>
              <Route path="" element={<Container />}>
                <Route path="" element={<ActivityPricePage />}/>
               {/* <Route path="scheduler" element={<SchedulerPage />}/>*/}
                <Route path="activity-prices" element={<ActivityPricePage />}/>
                <Route path="guide-schedule" element={<GuideSchedulePage />}/>
                <Route path="*" element={<NotFound session={state}/>}/>
              </Route>
            </Routes>
          </BrowserRouter>

        </ThemeProvider>
      </StateContext.Provider>
    </DispatchContext.Provider>
  );
};
